// Map raw server error codes returned by cart RPCs to friendly, user-facing text.
// Server side keeps machine-readable codes; UI decides how to phrase them.

const MAP: Record<string, string> = {
  "cart_not_found": "Your cart session expired. Please refresh and try again.",
  "not_found": "Your cart session expired. Please refresh and try again.",
  "context_required": "Choose a delivery area and date before adding to cart.",
  "unavailable:cutoff_passed_or_no_rule":
    "Ordering for this date has closed. Please pick a later delivery date.",
  "unavailable:not_on_menu_today": "This item is not on the menu for the selected date.",
  "unavailable:sold_out": "Sold out for the selected date.",
  "unavailable:no_price": "Pricing isn't available for this item yet.",
  "unavailable:area_not_served": "We don't deliver to this area yet.",
  "quantity_out_of_range": "Quantity must be between 1 and 10.",
  "item_not_found": "That item is no longer in your cart.",
  "cart_locked": "This cart is locked because checkout has started.",
  "cart_expired": "Your cart session expired. Please refresh and try again.",
  "rate_limited": "Too many changes at once — please try again in a moment.",
  "dish_selection_required": "Choose at least one dish from your upcoming menu before adding this plan.",
  "invalid_dish_selection": "One of the chosen dishes isn't part of this plan. Please pick from the menu shown.",
  "unknown_error": "Something went wrong. Please try again.",
};

export function friendlyCartError(code: string | undefined | null): string {
  if (!code) return MAP.unknown_error;
  if (MAP[code]) return MAP[code];
  // Handle "unavailable:*" fallbacks not explicitly listed.
  if (code.startsWith("unavailable:")) {
    const reason = code.slice("unavailable:".length).replace(/_/g, " ");
    return `Not available (${reason}).`;
  }
  return code.replace(/_/g, " ");
}